import React, { useState, useEffect } from "react";
import { Table, Card, Typography, message } from "antd";
import axios from "axios";

const { Title } = Typography;

export default function SalaryStatement() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const columns = [
        {
            title: "Employee Name",
            dataIndex: "employee_name",
            key: "employee_name",
        },
        {
            title: "Department",
            dataIndex: "department",
            key: "department",
        },
        {
            title: "Month",
            dataIndex: "month",
            key: "month",
        },
        {
            title: "Basic Pay",
            dataIndex: "basic_pay",
            key: "basic_pay",
            render: (text) => `₹${text.toLocaleString()}`,
        },
        {
            title: "Net Salary",
            dataIndex: "net_salary",
            key: "net_salary",
            render: (text) => `₹${text.toLocaleString()}`,
        },
    ];

    // 🔹 Example API call — replace URL with your endpoint later
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                // const res = await axios.get("http://yourapi.com/api/salary/");
                // setData(res.data);

                // Mock data for now:
                setData([
                    {
                        key: 1,
                        employee_name: "John Doe",
                        department: "Finance",
                        month: "September 2025",
                        basic_pay: 40000,
                        net_salary: 52000,
                    },
                    {
                        key: 2,
                        employee_name: "Jane Smith",
                        department: "HR",
                        month: "September 2025",
                        basic_pay: 38000,
                        net_salary: 49000,
                    },
                ]);
            } catch (err) {
                message.error("Failed to fetch salary data");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <>
            <Title level={4} style={{ marginBottom: "20px", textTransform: "uppercase", color: '#0e497b' }}>
                Salary Details
            </Title>

            <Table
                columns={columns}
                dataSource={data}
                bordered
                loading={loading}
                pagination={{ pageSize: 10 }}
                scroll={{ x: "max-content" }}
            />
        </>
    );
}
